import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DetailsTaskPreExistingConditions.css';
import { TYPES, usersUtil } from 'services/utils/users-util';
import { getCurrentUser } from 'selectors/authentication';
import {
  getCurrentTask,
  getPreExistingConditions,
  getPreExistingConditionsDescription,
} from 'selectors/admin/work-orders/details/details';
import { TaskStatusKeys } from 'domain/task-status-enum';
import { isTaskChecklistComplete } from 'services/utils/details-task-util';
import { getTasks } from 'selectors/admin/work-orders/work-orders';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import TextArea from 'components/shared/input/TextArea';
import Button from 'components/shared/button/Button';
import {
  removePreExistingConditionsImagesRequest,
  savePreExistingConditionsDescriptionRequest,
  updatePreExistingConditions,
  updatePreExistingConditionsDescription,
  uploadPreExistingConditionsImagesRequest,
} from 'actions/admin/work-orders/details/details';
import { Task } from 'domain/task';
import RadioButton from 'components/shared/radio-button/RadioButton';

class DetailsTaskPreExistingConditions extends Component {
  static propTypes = {
    currentTask: PropTypes.shape({}).isRequired,
    currentUser: PropTypes.shape({}).isRequired,
    preExistingConditions: PropTypes.bool,
    preExistingConditionsDescription: PropTypes.string,
    tasks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onPreExistingConditionsChange: PropTypes.func.isRequired,
    onPreExistingConditionsImageUpload: PropTypes.func.isRequired,
    onPreExistingConditionsImagesRemove: PropTypes.func.isRequired,
    onPreExistingConditionsDescriptionChange: PropTypes.func.isRequired,
    onPreExistingConditionsSave: PropTypes.func.isRequired,
  };

  static defaultProps = {
    preExistingConditions: null,
    preExistingConditionsDescription: '',
  };

  constructor(props) {
    super(props);

    this.userIsAdmin =
      usersUtil.isAdmin(props.currentUser) ||
      usersUtil.hasType(props.currentUser, TYPES.GENERAL_CONTRACTOR);
    this.userIsContractor =
      usersUtil.hasType(props.currentUser, TYPES.CONTRACTOR) ||
      (this.userIsAdmin && !props.currentTask.awardedContractor);
  }

  handlePreExistingConditionsChange = (value) => {
    this.props.onPreExistingConditionsChange(value === 'yes');
  };

  handlePreExistingConditionsDescriptionChange = (value) => {
    this.props.onPreExistingConditionsDescriptionChange(value);
  };

  handlePreExistingConditionsImageUpload = (taskChecklistId, images) => {
    this.props.onPreExistingConditionsImageUpload(taskChecklistId, images);
  };

  handleRemovePreConditionsImage = (images, taskChecklistId, imageIndex) => {
    this.props.onPreExistingConditionsImagesRemove(
      taskChecklistId,
      images[imageIndex].id
    );
  };

  handleSavePreExistingConditionsDescription = (taskChecklistId) => {
    this.props.onPreExistingConditionsSave(
      taskChecklistId,
      this.props.preExistingConditionsDescription
    );
  };

  render() {
    const { currentTask, tasks } = this.props;
    this.task = tasks.find((task) => task.id === currentTask.id);
    if (
      Task.isStatusFulFilled(currentTask, TaskStatusKeys.PRE) &&
      isTaskChecklistComplete(this.task)
    ) {
      if (this.userIsContractor && currentTask.status === TaskStatusKeys.PRE) {
        return this.renderEdit();
      } else {
        return this.renderReadOnly();
      }
    }
    return null;
  }

  renderEdit() {
    const {
      preExistingConditions,
      preExistingConditionsDescription,
    } = this.props;
    return (
      <div className="task-pre-conditions-container">
        <div className="h3">Pre-existing conditions</div>
        <span>Are there any pre-existing conditions?</span>
        <RadioButton
          options={[
            {
              value: 'yes',
              label: 'Yes',
            },
            {
              value: 'no',
              label: 'No',
            },
          ]}
          readOnly={
            this.task.task_checklist.pre_existing_images.length > 0 ||
            (preExistingConditionsDescription !== null &&
              preExistingConditionsDescription !== '')
          }
          value={
            preExistingConditions
              ? 'yes'
              : preExistingConditions !== null
              ? 'no'
              : null
          }
          onChange={this.handlePreExistingConditionsChange}
        />

        {preExistingConditions && (
          <div className="pre-existing-conditions">
            <ImageUpload
              extensions={['.jpg', '.jpeg', '.gif', '.png']}
              images={this.task.task_checklist.pre_existing_images.map(
                (image) => {
                  return {
                    preview: image.image.preview.url,
                  };
                }
              )}
              notes="Provide photos - close-up, distant"
              onRemove={this.handleRemovePreConditionsImage.bind(
                this,
                this.task.task_checklist.pre_existing_images,
                this.task.task_checklist.id
              )}
              onUpload={this.handlePreExistingConditionsImageUpload.bind(
                this,
                this.task.task_checklist.id
              )}
            />

            <div className="pre-existing-conditions-description">
              <TextArea
                placeholder="Enter a description"
                value={preExistingConditionsDescription}
                onChange={this.handlePreExistingConditionsDescriptionChange}
              />
              <Button
                className="button-orange"
                label="Save Description"
                onClick={this.handleSavePreExistingConditionsDescription.bind(
                  this,
                  this.task.task_checklist.id
                )}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderReadOnly() {
    if (
      this.task.task_checklist.pre_existing_images.length > 0 ||
      (this.task.task_checklist.pre_existing_desc !== null &&
        this.task.task_checklist.pre_existing_desc !== '')
    ) {
      return (
        <div className="task-pre-conditions-container">
          <div className="h3">Pre-existing conditions</div>
          <div className="pre-existing-conditions">
            <ImageUpload
              images={this.task.task_checklist.pre_existing_images.map(
                (image) => {
                  return {
                    preview: image.image.preview.url,
                    url: image.image.url,
                  };
                }
              )}
              readOnly={true}
            />
            <div className="pre-existing-conditions-description read-only">
              <div className="h4">Description</div>
              <div>{this.task.task_checklist.pre_existing_desc}</div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    currentTask: getCurrentTask(state),
    currentUser: getCurrentUser(state),
    preExistingConditions: getPreExistingConditions(state),
    preExistingConditionsDescription: getPreExistingConditionsDescription(
      state
    ),
    tasks: getTasks(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onPreExistingConditionsChange: (value) => {
    dispatch(updatePreExistingConditions(value));
  },
  onPreExistingConditionsDescriptionChange: (value) => {
    dispatch(updatePreExistingConditionsDescription(value));
  },
  onPreExistingConditionsImageUpload: (taskChecklistId, images) => {
    dispatch(uploadPreExistingConditionsImagesRequest(taskChecklistId, images));
  },
  onPreExistingConditionsImagesRemove: (taskChecklistId, imageId) => {
    dispatch(
      removePreExistingConditionsImagesRequest(taskChecklistId, imageId)
    );
  },
  onPreExistingConditionsSave: (taskChecklistId, description) => {
    dispatch(
      savePreExistingConditionsDescriptionRequest(taskChecklistId, description)
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailsTaskPreExistingConditions);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/tasks/DetailsTaskPreExistingConditions.js